import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState,
} from "react";

import api from "@/lib/api";


const AuthContext = createContext(null);


export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const { data } = await api.get(
                "/auth/me"
            );

            setUser(data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        checkAuth();
    }, [checkAuth]);

    const login = async (
        email,
        password
    ) => {
        const { data } = await api.post(
            "/auth/login",
            {
                email,
                password,
            }
        );

        setUser(data);
        return data;
    };

    const register = async (payload) => {
        const { data } = await api.post(
            "/auth/register",
            payload
        );

        if (!data.verification_required) {
            setUser(data);
        }

        return data;
    };

    const verifyRegistration = async (
        verificationId,
        code
    ) => {
        const { data } = await api.post(
            "/auth/verify-registration",
            {
                verification_id:
                    verificationId,
                code,
            }
        );

        setUser(data);
        return data;
    };

    const resendRegistrationCode =
        async (verificationId) => {
            const { data } = await api.post(
                "/auth/resend-registration-code",
                {
                    verification_id:
                        verificationId,
                }
            );

            return data;
        };

    const becomeSeller = useCallback(
        async () => {
            const {
                data,
            } = await api.post(
                "/auth/become-seller",
                {}
            );

            setUser(data);

            return data;
        },
        []
    );


    const logout = async () => {
        try {
            await api.post(
                "/auth/logout",
                {}
            );
        } catch {
            // ignore
        }

        setUser(null);
    };

    return (
        <AuthContext.Provider
            value={{
                user,
                setUser,
                loading,
                login,
                register,
                becomeSeller,
                verifyRegistration,
                resendRegistrationCode,
                logout,
                checkAuth,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}


export function useAuth() {
    const ctx = useContext(
        AuthContext
    );

    if (!ctx) {
        throw new Error(
            "useAuth must be inside AuthProvider"
        );
    }

    return ctx;
}
